import React from 'react';

import { Logo, LogoProps } from '@opendoor/bricks/core';

import { LegacyExternalLink } from 'platform/remix-run/react';

import { HOMEPAGE_URL } from 'shared/helpers/globals';

/**
 * The opendoor logo has two variants:
 * 1) Primary: Logo with full name Opendoor spelled out.
 * 2) Secondary: Logo with just the O from Opendoor.
 * Opendoor logo defaults to use the primary variant if no variant is defined
 */
export const OpendoorLogo: React.FC<LogoProps> = ({ height = '28px', variant, ...props }) => (
  <LegacyExternalLink
    href={HOMEPAGE_URL}
    analyticsName={variant === 'primary' ? 'opendoor-full-logo' : 'opendoor-o-logo'}
    // @ts-expect-error custom lineHeight value
    lineHeight={variant === 'primary' ? 's3' : 0}
    aria-label="Go back to last page."
  >
    <Logo height={height} variant={variant} {...props} />
  </LegacyExternalLink>
);
